import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AuthNewService} from '../../../service/auth-new.service';
import { DBService } from '../../../service/DB.service';

@Component({
    template: ``,
    standalone: false
})
export class UserSignOutComponent implements OnInit {

  constructor(private authService: AuthNewService,
              private dbService: DBService,
              private router: Router) { }

  ngOnInit(): void {
    this.recordLogoutData();
    this.authService.handleSignout();
    this.router.navigate(['extra-layout/home']);
  }

  recordLogoutData() {
//     console.log('Attempting to record login');
//     sessionStorage.removeItem('xyz');
//     sessionStorage.removeItem('login-data');
//     sessionStorage.removeItem('analysis-data');
    this.dbService.recordAuthEvent('logout').subscribe((data: string) => {
//       console.log('RECORDED LOGOUT DATA', data);
    });
  }
}
